/**
 * Define the Route List items
 */
import React from 'react';
import NoPermission from '../Modules/Core/NoPermission/NoPermission';

import LoginPage from '../Modules/Core/Login/Pages/Login';
/** Home */
import Home from '../Modules/Dashboard/Pages/Home';

import AzureRedirectComponent from '../Modules/Core/Login/Pages/AzureRedirectComponent';
import SocialMediaRedirectComponent from '../Modules/Core/Login/Pages/SocialMediaRedirectComponent';
import Register from '../Modules/Core/Login/Pages/Register';
import NewPassword from '../Modules/Core/Login/Pages/NewPassword';
import ForgotPassword from '../Modules/Core/Login/Pages/ForgotPassword';
import Products from '../Modules/Products/Pages/Products';
import LoadCommands from '../Modules/Core/Command/Pages/Commands';
import Tests from '../Modules/Autest/Test/Pages/Tests';
import AddTest from '../Modules/Autest/Test/Pages/AddTest';
import AddCommand from '../Modules/Core/Command/Pages/AddCommand';
import UserTenant from '../Modules/Core/Login/Pages/UserTenant';
import TestCases from '../Modules/Autest/TestCases/Pages/TestCases';
import AddTestCase from '../Modules/Autest/TestCases/Pages/AddTestCase';
import DeviceEnrollment from '../Modules/SmartRF/DeviceEnrollment/Pages/DeviceEnrollment';
import RemoteServers from '../Modules/Autest/RemoteServer/Pages/RemoteServers';
import AddRemoteServer from '../Modules/Autest/RemoteServer/Pages/AddRemoteServer';
import RunSets from '../Modules/Autest/RunSet/Pages/RunSets';
import AddRunSet from '../Modules/Autest/RunSet/Pages/AddRunSet';
import Profile from '../Modules/Core/Profile/Profile';
import ExecutionDashboard from '../Modules/Autest/Execution/Pages/ExecutionDashboard';
import Executions from '../Modules/Autest/Execution/Pages/Executions';
import AddRFProfile from '../Modules/SmartRF/RFProfile/Pages/AddRFProfile.tsx';
import RFProfileGroup from '../Modules/SmartRF/RFProfileGroup/Pages/RFProfileGroup';
import AddRFProfileGroup from '../Modules/SmartRF/RFProfileGroup/Pages/AddRFProfileGroup';
import Organization from '../Modules/Organization/OrganizationDetail/Organization';
import RFFormInfo from '../Modules/SmartRF/RFFormInfo/Pages/RFFormInfo';
import AddRFFormInfo from '../Modules/SmartRF/RFFormInfo/Pages/AddRFFormInfo';
import RFFieldInfo from '../Modules/SmartRF/RFFieldInfo/Pages/RFFieldInfo';
import AddRFFieldInfo from '../Modules/SmartRF/RFFieldInfo/Pages/AddRFFieldInfo';
import OrganizationProducts from '../Modules/Organization/OrganizationProducts/Pages/OrganizationProducts';
import OrganizationUser from '../Modules/Organization/OrganizationUsers/Pages/OrganizationUser';
import PasswordChange from '../Modules/Core/PasswordChange/PasswordChange';
import AppFlow from '../Modules/Autest/AppFlow/Pages/AppFlow';
import AddAppFlow from '../Modules/Autest/AppFlow/Pages/AddAppFlow';
import AutestDashboard from '../Modules/Autest/Dashboard/Pages/AutestDashboard';
import RFDashboard from '../Modules/SmartRF/Dashboard/Pages/SmartRFDashboard';
import AdminOrganization from '../Modules/Admin/Organization/Pages/Organization';
import AddOrganization from '../Modules/Admin/Organization/Pages/AddOrganization';
import AdminProduct from '../Modules/Admin/Product/Pages/Product';
import AddProduct from '../Modules/Admin/Product/Pages/AddProduct';
import RFDevice from '../Modules/SmartRF/RFDevice/Pages/RFDevice';
import AddRFDevice from '../Modules/SmartRF/RFDevice/Pages/AddRFDevice';
import Blob from '../Modules/Admin/Blob/Pages/Blob';
import AddBlob from '../Modules/Admin/Blob/Pages/AddBlob';
import GlobalConfiguration from '../Modules/Admin/GlobalConfiguration/Pages/GlobalConfiguration';
import AddGlobalConfiguration from '../Modules/Admin/GlobalConfiguration/Pages/AddGlobalConfiguration';
import AdminRoles from '../Modules/Admin/Roles/Pages/Roles';
import AddRole from '../Modules/Admin/Roles/Pages/AddRole';
import AdminLookup from '../Modules/Admin/Lookup/Pages/Lookup';
import AddLookup from '../Modules/Admin/Lookup/Pages/AddLookup';
import IntegrationType from '../Modules/Maintenance/IntegrationType/Pages/IntegrationType';
import AddIntegrationType from '../Modules/Maintenance/IntegrationType/Pages/AddIntegrationType';
import IntegrationSystem from '../Modules/Integrations/IntegrationSystem/Pages/IntegrationSystem';
import AddIntegrationSystem from '../Modules/Integrations/IntegrationSystem/Pages/AddIntegrationSystem';
import AddIntegrationConnection from '../Modules/Integrations/IntegrationConnection/Pages/AddIntegrationConnection';
import SettingDataType from '../Modules/Maintenance/SettingDataType/Pages/SettingDataType';
import AddSettingDataType from '../Modules/Maintenance/SettingDataType/Pages/AddSettingDataType';
import AddConnectionType from '../Modules/Maintenance/ConnectionType/Pages/AddConnectionType';
import { AUTH_PERMISSION } from '../constants/applicationConstants';
import LoginCallback from '../Modules/Core/Login/Pages/LoginCallback';
import LogoutCallback from '../Modules/Core/Login/Pages/LogoutCallback';
import DashboardApi from '../Modules/Core/Login/Pages/DashboardApi';

const RoutesItemsList = [
  {
    text: '',
    icon: '',
    route: '/login',
    element: <LoginPage />,
    layouts: 'EmptyLayout',
    is_drawer_item: 'false',
    page_title: 'Login',
    isauth: false,
    is_mobile: 'true',
  },
  {
    text: '',
    icon: '',
    route: '/logout_callback',
    element: <LogoutCallback />,
    layouts: 'EmptyLayout',
    is_drawer_item: 'false',
    page_title: 'Logout Callback',
    isauth: false,
    is_mobile: 'true',
  },
  {
    id: 19,
    text: 'Login Callback',
    icon: '',
    route: '/callback/smart-oidc',
    element: <LoginCallback />,
    layouts: 'EmptyLayout',
    is_drawer_item: 'false',
    page_title: 'Login Callback',
    isauth: false,
    is_mobile: 'true',
  },
  {
    text: '',
    icon: '',
    route: '/tenant/request',
    element: <UserTenant />,
    layouts: 'AuthEmptyLayout',
    is_drawer_item: 'false',
    page_title: 'Login',
    isauth: true,
    is_mobile: 'true',
  },
  {
    text: '',
    icon: '',
    route: '/register',
    element: <Register />,
    layouts: 'EmptyLayout',
    is_drawer_item: 'false',
    page_title: 'Register',
    isauth: false,
    is_mobile: 'true',
  },
  {
    text: '',
    icon: '',
    route: '/new-password/:token?',
    element: <NewPassword />,
    layouts: 'EmptyLayout',
    is_drawer_item: 'false',
    page_title: 'New Password',
    isauth: false,
    is_mobile: 'true',
  },
  {
    text: '',
    icon: '',
    route: '/forgot-password',
    element: <ForgotPassword />,
    layouts: 'EmptyLayout',
    is_drawer_item: 'false',
    page_title: 'Forgot Password',
    isauth: false,
    is_mobile: 'true',
  },

  /** Dashboard */
  {
    text: 'Dashboard',
    iconReact: 'LuHome',
    element: <Home />,
    route: '/',
    id: 1,
    layouts: 'DashboardLayout',
    is_drawer_item: 'true',
    page_title: 'Dashboard',
    isauth: true,
    is_mobile: 'true',
  },
  {
    text: 'Dashboard API',
    icon: '',
    route: '/dashboardapi',
    element: <DashboardApi />,
    layouts: 'CardLayout',
    is_drawer_item: 'false',
    page_title: 'Dashboard API',
    isauth: true,
    is_mobile: 'true',
  },
  {
    id: 3,
    text: 'Products',
    icon: '',
    iconReact: 'LuPackage',
    route: '/products',
    element: <Products />,
    layouts: 'DashboardLayout',
    is_drawer_item: 'true',
    page_title: 'Products',
    isauth: true,
    is_mobile: 'true',
  },
  {
    id: 25,
    text: 'Profile',
    icon: '',
    route: '/profile',
    element: <Profile />,
    layouts: 'TileLayout',
    is_drawer_item: 'false',
    page_title: 'Profile',
    isauth: true,
    is_mobile: 'true',
  },
  {
    text: 'No Permission',
    route: '/no-permission',
    element: <NoPermission />,
    layouts: 'TileLayout',
    is_drawer_item: 'false',
    is_mobile: 'false',
  },
  {
    text: 'AuTest',
    icon: 'k-i-tell-a-friend',
    iconReact: 'LuFlaskConical',
    'data-expanded': false,
    id: 4,
    layouts: 'TileLayout',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'Dashboard',
    iconReact: 'LuLayoutDashboard',
    id: 45,
    parentid: 4,
    page_title: 'Autest Dashboard',
    element: <AutestDashboard />,
    route: '/autest/overview',
    layouts: 'DashboardLayout',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'Global',
    iconReact: 'LuGlobe',
    id: 5,
    parentid: 4,
    'data-expanded': false,
    layouts: 'CardLayout',
    page_title: 'Global',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'Application Flow',
    iconReact: 'LuWaypoints',
    id: 10,
    parentid: 5,
    route: '/autest/flows',
    layouts: 'CardLayout',
    element: <AppFlow />,
    page_title: 'Application Flow',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'Command Maintenance',
    iconReact: 'LuCode',
    id: 11,
    parentid: 5,
    route: '/autest/commands',
    layouts: 'CardLayout',
    element: <LoadCommands />,
    page_title: 'Command Maintenance',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'Test',
    iconReact: 'LuFlaskConical',
    id: 12,
    parentid: 5,
    route: '/autest/tests',
    layouts: 'CardLayout',
    element: <Tests />,
    page_title: 'Test',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'AddAppFlow',
    icon: 'k-i-minus',
    id: 25,
    parentid: 5,
    route: '/autest/flow/:tenantId',
    layouts: 'TileLayout',
    element: <AddAppFlow />,
    page_title: 'Add Flow',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'AddTest',
    icon: 'k-i-minus',
    id: 13,
    parentid: 5,
    route: '/autest/test/:tenantId',
    layouts: 'TileLayout',
    element: <AddTest />,
    page_title: 'Add Test',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'AddLCS',
    icon: 'k-i-minus',
    id: 13,
    parentid: 5,
    route: '/autest/command/:tenantId',
    layouts: 'TileLayout',
    element: <AddCommand />,
    page_title: 'Add Command',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'Test Case',
    iconReact: 'LuTestTubeDiagonal',
    id: 16,
    parentid: 5,
    route: '/autest/testcases',
    layouts: 'CardLayout',
    element: <TestCases />,
    page_title: 'Test Case',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'Add Test Case',
    icon: 'k-i-minus',
    id: 12,
    parentid: 5,
    route: '/autest/testcase/:tenantId',
    layouts: 'TileLayout',
    element: <AddTestCase />,
    page_title: 'Add Test Case',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'Runtime',
    iconReact: 'LuRotateCwSquare',
    id: 6,
    parentid: 4,
    'data-expanded': false,
    layouts: 'CardLayout',
    page_title: 'Runtime',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'Remote Server',
    icon: 'k-i-minus',
    id: 21,
    parentid: 6,
    route: '/autest/remote-servers',
    layouts: 'CardLayout',
    element: <RemoteServers />,
    page_title: 'Remote Server',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'false',
    AuthPermission: 'Autest',
  },
  {
    text: 'Add Remote Server',
    icon: 'k-i-minus',
    id: 17,
    parentid: 6,
    route: '/autest/remote-server',
    layouts: 'TileLayout',
    element: <AddRemoteServer />,
    page_title: 'Add Remote Server',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'Run Set',
    iconReact: 'LuChartCandlestick',
    id: 18,
    parentid: 6,
    route: '/autest/run-sets',
    layouts: 'CardLayout',
    element: <RunSets />,
    page_title: 'Run Set',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'Add Run Set',
    icon: 'k-i-minus',
    id: 19,
    parentid: 6,
    route: '/autest/run-set/:tenantId',
    layouts: 'TileLayout',
    element: <AddRunSet />,
    page_title: 'Add Run Set',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'Executions',
    iconReact: 'LuZap',
    id: 26,
    parentid: 4,
    'data-expanded': false,
    layouts: 'CardLayout',
    page_title: 'Executions',
    is_drawer_item: 'true',
    isauth: false,
    is_mobile: 'true',
  },
  {
    text: 'Dashboard',
    iconReact: 'LuLayoutDashboard',
    id: 27,
    parentid: 26,
    route: '/autest/executions/dashboard',
    layouts: 'DashboardLayout',
    page_title: 'Execution Dashboard',
    element: <ExecutionDashboard />,
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
  },
  {
    text: 'Results',
    iconReact: 'LuClipboardCheck',
    id: 48,
    parentid: 26,
    route: '/autest/executions',
    layouts: 'CardLayout',
    page_title: 'Results',
    element: <Executions />,
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'Autest',
  },
  {
    text: 'RF++',
    id: 24,
    layouts: 'TileLayout',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    iconReact: 'LuTabletSmartphone',
    AuthPermission: 'RF',
  },
  {
    text: 'Dashboard',
    iconReact: 'LuLayoutDashboard',
    id: 44,
    parentid: 24,
    page_title: 'RF++ Dashboard',
    element: <RFDashboard />,
    route: '/smartrf/overview',
    layouts: 'DashboardLayout',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'RF',
  },
  {
    text: 'Device Enrollment',
    parentid: 24,
    id: 23,
    iconReact: 'LuSmartphoneCharging',
    route: '/smartrf/device-enrollment',
    layouts: 'CardLayout',
    element: <DeviceEnrollment />,
    page_title: 'Device Enrollment',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'RF',
  },
  {
    text: 'Profiles',
    iconReact: 'LuMonitorCog',
    id: 28,
    parentid: 24,
    route: '/smartrf/profile-groups',
    layouts: 'CardLayout',
    element: <RFProfileGroup />,
    page_title: 'Profile Group',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'RF',
  },
  {
    text: 'Add Profile Group',
    icon: 'k-i-minus',
    id: 31,
    parentid: 24,
    route: '/smartrf/profile-group/:tenantId',
    layouts: 'TileLayout',
    element: <AddRFProfileGroup />,
    page_title: 'Add Profile Group',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'RF',
  },
  {
    text: 'Add Profile',
    icon: 'k-i-minus',
    id: 29,
    parentid: 24,
    route: '/smartrf/profile/:tenantId',
    layouts: 'TileLayout',
    element: <AddRFProfile />,
    page_title: 'Add Profile',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'RF',
  },
  {
    text: 'Form Info',
    iconReact: 'LuChartBar',
    id: 32,
    parentid: 24,
    route: '/smartrf/form-infos',
    layouts: 'CardLayout',
    element: <RFFormInfo />,
    page_title: 'Form Info',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'RF',
  },
  {
    text: 'Add Form Info',
    icon: 'k-i-minus',
    id: 33,
    parentid: 24,
    route: '/smartrf/form-info/:tenantId',
    layouts: 'TileLayout',
    element: <AddRFFormInfo />,
    page_title: 'Add Form Info',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'RF',
  },
  {
    text: 'Field Info',
    iconReact: 'LuSquareChartGantt',
    id: 34,
    parentid: 24,
    route: '/smartrf/field-infos',
    layouts: 'CardLayout',
    element: <RFFieldInfo />,
    page_title: 'Field Info',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'RF',
  },
  {
    text: 'Add Field Info',
    icon: 'k-i-minus',
    id: 35,
    parentid: 24,
    route: '/smartrf/field-info/:tenantId',
    layouts: 'TileLayout',
    element: <AddRFFieldInfo />,
    page_title: 'Add Field Info',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'RF',
  },
  {
    text: 'Devices',
    iconReact: 'LuSmartphone',
    id: 49,
    parentid: 24,
    route: '/smartrf/devices',
    layouts: 'CardLayout',
    element: <RFDevice />,
    page_title: 'Devices',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'RF',
  },
  {
    text: 'Add Device',
    icon: 'k-i-minus',
    id: 50,
    parentid: 24,
    route: '/smartrf/device',
    layouts: 'TileLayout',
    element: <AddRFDevice />,
    page_title: 'Add Device',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: 'RF',
  },
  {
    text: 'Integration',
    'data-expanded': false,
    id: 62,
    page_title: 'Integration',
    layouts: 'TileLayout',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    iconReact: 'LuHousePlug',
  },
  {
    text: 'Integration Systems',
    icon: 'sis-ico-dashboard',
    id: 63,
    parentid: 62,
    page_title: 'Integration Systems',
    element: <IntegrationSystem />,
    route: '/integration/systems',
    layouts: 'CardLayout',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    iconReact: 'LuPlug',
  },
  {
    text: 'Add Integration System',
    icon: 'sis-ico-dashboard',
    id: 64,
    parentid: 62,
    page_title: 'Add Integration System',
    element: <AddIntegrationSystem />,
    route: '/integration/system/:tenantId',
    layouts: 'TileLayout',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
  },
  {
    text: 'Add Integration Connection',
    icon: 'sis-ico-dashboard',
    id: 65,
    parentid: 62,
    page_title: 'Add Integration Connection',
    element: <AddIntegrationConnection />,
    route: '/integration/connection/:tenantId',
    layouts: 'TileLayout',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
  },  
  {
    footer_start: true,
    is_drawer_item: 'true',
  },
  {
    text: 'Organization',
    'data-expanded': false,
    id: 30,
    page_title: 'Organizations',
    layouts: 'CardLayout',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    iconReact: 'LuBuilding2',
    AuthPermission: AUTH_PERMISSION?.OrganizationUser,
  },
  {
    text: 'Details',
    iconReact: 'LuBuilding2',
    id: 91,
    parentid: 30,
    route: '/organization',
    layouts: 'TileLayout',
    element: <Organization />,
    page_title: 'Organization',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.OrganizationUser,
  },
  {
    text: 'Products',
    iconReact: 'LuPackage',
    id: 36,
    parentid: 30,
    route: '/organization-products',
    layouts: 'DashboardLayout',
    element: <OrganizationProducts />,
    page_title: 'Products',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.OrganizationUser,
  },
  {
    text: 'Users',    
    iconReact: 'LuUsers',
    id: 37,
    parentid: 30,
    route: '/organization-users',
    layouts: 'TileLayout',
    element: <OrganizationUser />,
    page_title: 'Users',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.OrganizationAdmin,
  },
  {
    text: 'Redirect',
    route: '/AzureAdAuth/Callback',
    element: <AzureRedirectComponent />,
    layouts: 'EmptyLayout',
    is_drawer_item: 'false',
    is_mobile: 'false',
  },
  {
    id: 38,
    text: 'Password Change',
    icon: '',
    route: '/change-password',
    element: <PasswordChange />,
    layouts: 'TileLayout',
    is_drawer_item: 'false',
    page_title: 'Password Change',
    isauth: true,
    is_mobile: 'true',
  },
  {
    text: 'Redirect',
    route: '/SocialMediaAuth/CallBack',
    element: <SocialMediaRedirectComponent />,
    layouts: 'EmptyLayout',
    is_drawer_item: 'false',
    is_mobile: 'false',
  },
  {
    text: 'Admin',
    icon: 'k-i-tell-a-friend',
    ['data-expanded']: false,
    id: 39,
    page_title: 'Admin',
    layouts: 'CardLayout',
    is_drawer_item: 'true',
    isauth: false,
    is_mobile: 'true',
    iconReact: 'LuShield',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Organizations',
    iconReact: 'LuBuilding2',
    id: 40,
    parentid: 39,
    route: '/admin/organizations',
    layouts: 'TileLayout',
    element: <AdminOrganization />,
    page_title: 'Organizations',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Add Organization',
    icon: 'k-i-minus',
    id: 41,
    parentid: 39,
    route: '/admin/organization',
    layouts: 'TileLayout',
    element: <AddOrganization />,
    page_title: 'Add Organization',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Blob',
    iconReact: 'LuFile',
    id: 42,
    parentid: 39,
    route: '/admin/blobs',
    layouts: 'CardLayout',
    element: <Blob />,
    page_title: 'Blob',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Add Blob',
    icon: 'k-i-minus',
    id: 43,
    parentid: 39,
    route: '/admin/blob/:tenantId',
    layouts: 'TileLayout',
    element: <AddBlob />,
    page_title: 'Add Blob',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Products',
    iconReact: 'LuPackage',
    id: 46,
    parentid: 39,
    route: '/admin/products',
    layouts: 'DashboardLayout',
    element: <AdminProduct />,
    page_title: 'Products',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Add Product',
    icon: 'k-i-minus',
    id: 47,
    parentid: 39,
    route: '/admin/product',
    layouts: 'TileLayout',
    element: <AddProduct />,
    page_title: 'Add Product',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Lookup',
    iconReact: 'LuPackageSearch',
    id: 53,
    parentid: 39,
    route: '/admin/lookups',
    layouts: 'CardLayout',
    element: <AdminLookup />,
    page_title: 'Lookup',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Add Lookup',
    icon: 'k-i-minus',
    id: 54,
    parentid: 39,
    route: '/admin/lookup',
    layouts: 'TileLayout',
    element: <AddLookup />,
    page_title: 'Add Lookup',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Roles',
    iconReact: 'LuUserStar',
    id: 55,
    parentid: 39,
    route: '/admin/roles',
    layouts: 'CardLayout',
    element: <AdminRoles />,
    page_title: 'Roles',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Add Role',
    icon: 'k-i-minus',
    id: 56,
    parentid: 39,
    route: '/admin/role',
    layouts: 'TileLayout',
    element: <AddRole />,
    page_title: 'Add Role',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Global Configuration',
    iconReact: 'LuCog',
    id: 57,
    parentid: 39,
    route: '/admin/global-configurations',
    layouts: 'CardLayout',
    element: <GlobalConfiguration />,
    page_title: 'Global Configuration',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Add Global Configuration',
    icon: 'k-i-minus',
    id: 58,
    parentid: 39,
    route: '/admin/global-configuration',
    layouts: 'TileLayout',
    element: <AddGlobalConfiguration />,
    page_title: 'Add Global Configuration',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Maintenance',
    iconReact: 'LuSlidersHorizontal',
    'data-expanded': false,
    id: 59,
    parentid: 39,
    page_title: 'Maintenance',
    layouts: 'TileLayout',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Integration',
    iconReact: 'LuPlugZap',
    'data-expanded': false,
    id: 60,
    parentid: 59,
    page_title: 'Integration',
    layouts: 'TileLayout',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'System Types',
    iconReact: 'LuSendToBack',
    id: 66,
    parentid: 60,
    page_title: 'System Types',
    element: <IntegrationType />,
    route: '/admin/integration-types',
    layouts: 'CardLayout',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Add System Type',
    iconReact: 'LuPlugZap',
    id: 67,
    parentid: 60,
    page_title: 'Add System Type',
    element: <AddIntegrationType />,
    route: '/admin/integration-type',
    layouts: 'TileLayout',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Data Types',
    iconReact: 'LuBringToFront',
    id: 68,
    parentid: 60,
    page_title: 'Data Types',
    element: <SettingDataType />,
    route: '/admin/data-types',
    layouts: 'CardLayout',
    is_drawer_item: 'true',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Add Data Type',
    id: 69,
    parentid: 60,
    page_title: 'Add Data Type',
    element: <AddSettingDataType />,
    route: '/admin/data-type',
    layouts: 'TileLayout',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
  {
    text: 'Add Connection Type',
    icon: 'sis-ico-dashboard',
    id: 70,
    parentid: 60,
    page_title: 'Add Connection Type',
    element: <AddConnectionType />,
    route: '/admin/connection-type',
    layouts: 'TileLayout',
    is_drawer_item: 'false',
    isauth: true,
    is_mobile: 'true',
    AuthPermission: AUTH_PERMISSION?.Admin,
  },
];

const RoutesItems = RoutesItemsList;

export default RoutesItems;
